import React from "react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_5f66e06f-babb-477d-81df-046e9cca7dda/artifacts/h62m3jh2_bush%20maps%20logo.png";

export default function Footer() {
  return (
    <footer className="bg-[#2D2621] text-[#D7CFC0]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-12 h-12 rounded-full overflow-hidden border border-[#6B7A6A]">
                <img
                  src={LOGO_URL}
                  alt="Bush Maps"
                  className="w-full h-full object-cover"
                />
              </span>
              <span className="font-serif-display text-2xl text-[#FDFBF7]">
                Bush Maps
              </span>
            </div>
            <p className="mt-6 text-sm leading-relaxed text-[#A89E94] max-w-sm">
              Illustrated knowledge maps developed with Traditional Owners.
              SeedKeepers · Caring for Country.
            </p>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.28em] uppercase text-[#E9C7A8] mb-4">
              Explore
            </div>
            <ul className="space-y-2 text-sm">
              <li><a href="/#what-is" className="hover:text-[#FDFBF7]">What is a Bush Map</a></li>
              <li><a href="/#examples" className="hover:text-[#FDFBF7]">Example Maps</a></li>
              <li><a href="/#outputs" className="hover:text-[#FDFBF7]">Project Outputs</a></li>
              <li><a href="/#authority" className="hover:text-[#FDFBF7]">Community Authority</a></li>
              <li><a href="/approach" className="hover:text-[#FDFBF7]">Our Approach</a></li>
              <li><a href="/#contact" className="hover:text-[#FDFBF7]">Start a Project</a></li>
            </ul>
          </div>

          <div>
            <div className="text-[11px] tracking-[0.28em] uppercase text-[#E9C7A8] mb-4">
              Contact
            </div>
            <div className="text-[#FDFBF7] font-serif-display text-xl">
              William Martin
            </div>
            <div className="text-sm text-[#A89E94] mt-1">
              <a
                href="https://www.seedkeepers.com.au"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-[#FDFBF7] transition-colors"
              >
                SeedKeepers · Caring for Country
              </a>
            </div>
            <a
              href="mailto:william@bushmaps.com.au"
              className="mt-3 inline-block text-sm text-[#E9C7A8] hover:text-[#FDFBF7]"
            >
              william@bushmaps.com.au
            </a>
          </div>
        </div>

        <div className="bm-hairline mt-12 mb-6" />

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-[#7A6C63]">
          <p className="max-w-2xl leading-relaxed">
            We acknowledge Traditional Owners of Country throughout Australia
            and pay respect to Elders past, present and emerging. Sovereignty
            was never ceded.
          </p>
          <p>© {new Date().getFullYear()} Bush Maps. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
